import { styled, Chip, ChipProps } from "@mui/material";
import { AssetTypeAlphaColor, GetAssetObjectReadableType } from "../../../../Utils/helpers";
import { ObjectType } from "../../../../Core/Api/Types/object-type";
import AssetIcon from "../../AssetIcon/asset-icon";
import { ReactNode } from "react";

export enum AssetTypeLogo {
  DolbyAtmosWhite,
}

export interface AssetTypeChipProps extends ChipProps {
  type: ObjectType;
  uncolored?: boolean;
  logo?: AssetTypeLogo;
}

const AssetTypeChip: React.FC<AssetTypeChipProps> = (props) => {
  const { type, uncolored = false, logo, label, variant = "filled", ...otherProps } = props;
  let _icon = <AssetIcon type={type} />;
  let _label: any = label ? label : GetAssetObjectReadableType(type);

  if (logo === AssetTypeLogo.DolbyAtmosWhite)
    _label = (
      <img src="/static/images/logos/logo-dolby-atmos-white.png" alt="Atmos" width="80" style={{ paddingTop: 5 }} />
    );

  return <StyledChip type={type} uncolored={uncolored} variant={variant} icon={_icon} label={_label} {...otherProps} />;
};

export default AssetTypeChip;

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "type" && prop !== "uncolored" && prop !== "logo" && prop !== "variant",
})<{
  type: AssetTypeChipProps["type"];
  uncolored: AssetTypeChipProps["uncolored"];
  variant: string;
}>(({ theme, uncolored, type, variant }) => {
  const styles = {};
  if (uncolored) return { ...styles };

  return {
    ...styles,
    ...(variant === "filled" && {
      color: theme.palette.mode === "dark" ? theme.palette.text.primary : AssetTypeAlphaColor(type, 1),
      backgroundColor: theme.palette.mode === "dark" ? AssetTypeAlphaColor(type, 0.65) : AssetTypeAlphaColor(type, 0.1),
      ".MuiSvgIcon-root": {
        color: theme.palette.mode === "dark" ? theme.palette.text.primary : AssetTypeAlphaColor(type, 1),
      },
    }),
    ...(variant === "outlined" && {
      color: AssetTypeAlphaColor(type, 1),
      backgroundColor: theme.palette.mode === "dark" ? AssetTypeAlphaColor(type, 0.1) : AssetTypeAlphaColor(type, 0.1),
      ".MuiSvgIcon-root": {
        color: theme.palette.mode === "dark" ? AssetTypeAlphaColor(type, 1) : AssetTypeAlphaColor(type, 1),
      },
    }),
  };
});
